import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppSelector } from '@/redux/hooks';
import { getUrlFromPathname } from '@/redux/modules/config';
import { track } from '@/utils/amplitude/analytics/core';
import { TrackingEvents, TrackingPayload } from '@/utils/amplitude/analytics/core.types';
import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';

export const AppDownloadPromptTrigger = {
    LeadingBidder: 'Leading Bidder',
    Save: 'Save',
} as const;

export type AppDownloadPromptTriggerValue = (typeof AppDownloadPromptTrigger)[keyof typeof AppDownloadPromptTrigger];

type TrackAppDownloadPromptViewedPayload = TrackingPayload & {
    trigger: AppDownloadPromptTriggerValue;
};

export const trackAppDownloadPromptViewed = (payload: TrackAppDownloadPromptViewedPayload) => {
    track(TrackingEvents.Notifications.AppDownloadPromptViewed, payload);
};

export const useTrackAppDownloadPromptViewed = () => {
    const { pathname } = useLocation();
    const url = useAppSelector((state) => getUrlFromPathname(state, pathname));

    return useCallback(
        ({ trigger }: Omit<TrackAppDownloadPromptViewedPayload, 'pageName' | 'url'>) => {
            trackAppDownloadPromptViewed({
                pageName: getAmplitudePageNameFromPath(pathname),
                trigger,
                url,
            });
        },
        [pathname, url]
    );
};
